import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTheme } from '@mui/material';
import authActions from 'actions/authActions';

import Stack from 'components/core/Stack';
import Sheet from 'components/core/Sheet';
import Typography from 'components/core/Typography';
import Avatar from 'components/core/Avatar';
import IconButton from 'components/core/IconButton';
import { Home, Search, AdminPanelSettings, Logout } from '@mui/icons-material';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const Sidebar = () => {
    const me = useSelector(({ profile }) => profile.me);
    const location = useLocation();
    const theme = useTheme();
    const dispatch = useDispatch();

    
    const userNavItem = [
        { label: 'Home', Icon: Home, path: '/' },
        { label: 'Taxonomy Search', Icon: Search, path: '/taxonomy/search' },
        { label: 'Add Observation', Icon: AddCircleOutlineIcon, path: '/observation/add' },
        { label: 'Observation Import', Icon: SaveAltIcon, path: '/observation/import' },
        { label: 'Observation Query', Icon: Search, path: '/observation-query' },
        { label: 'Location Query', Icon: Search },
        { label: 'Person Query', Icon: Search },
        { label: 'About Us', Icon: Home },
    ];

    const adminNavItems = [
        ...userNavItem,
        { label: 'System Admin', Icon: AdminPanelSettings, path: '/system-admin' },
    ];
    const navItems = me?.type === 'ADMIN' ? adminNavItems : userNavItem;

    const handleLogout = () => {
        dispatch(authActions.logout());
    }
    
    return (
        <Sheet 
            sx={{
                width: 250,
                height: '100vh', 
                backgroundColor: 'white',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                padding: 0,
                boxShadow: '10px 0px 20px rgba(0, 0, 0, 0.1)'
            }}
        >
            <Stack>

                <img
                    src={'./img/BORIIS2 Logo.png'}
                    alt={''}
                    width={250} 
                    style={{marginTop: 34, marginBottom: 34, padding: 8}}
                />

                {navItems.map(({ label, Icon, path }) => {
                    let color;
                    if (location.pathname === path) {
                        color = 'black';
                    } else if (!path) {
                        color = 'lightgrey';
                    } else {
                        color = 'grey.500';
                    }
                    return (
                        <Link
                            key={label}
                            to={path}
                            disabled={!path}
                            style={{
                                paddingTop: theme.spacing(2),
                                paddingBottom: theme.spacing(2),
                                display: 'flex',
                                alignItems: 'center',
                                color: color,
                                fontWeight: location.pathname === path ? 'bold' : 'normal',
                                textDecoration: 'none',
                                paddingLeft: 8,
                                borderLeft: location.pathname === path ? `8px solid ${theme.palette.primary[500]}` : 'none',
                                background: location.pathname === path ? theme.palette.primary[100] : 'none'
                            }}
                        >
                            <Icon 
                                style={{ color: color }}
                            />
                            <Typography style={{ marginLeft: 8, color: color }}>{label}</Typography>
                        </Link>
                    )
                })}
            </Stack>

            { me && (
                <Stack 
                    direction="row" 
                    spacing={2} 
                    alignItems="center" 
                    sx={{ marginBottom: theme.spacing(2) }}
                >

                    <Avatar>{me.firstName[0] + me.lastName[0]}</Avatar>
                    <Typography>
                        {me.firstName} {me.lastName}
                    </Typography>
                    <IconButton onClick={handleLogout}>
                        <Logout />
                    </IconButton>
                </Stack>
            )}
        </Sheet>
    )
};

export default Sidebar;